<template>
  <FilterBadge v-bind="{ ...$props, ...$attrs }" icon="fas fa-share-alt">
    {{ text }}
  </FilterBadge>
</template>

<script setup lang="ts">
import { computed, type PropType } from "vue";
import { useTranslation } from "@/language/translation";
import { SQDCBoardEventStatus } from "@/graphql";
import BoardOriginFilter from "../../filterImplementations/BoardOriginFilter";
import FilterBadge from "./FilterBadge.vue";

const props = defineProps({
  filter: {
    type: Object as PropType<BoardOriginFilter>,
    required: true,
  },
});
const { t } = useTranslation();
const text = computed(() => {
  switch (props.filter.boardOrigin) {
    case SQDCBoardEventStatus.ESCALATED:
      return t("components.event-action.issue.BoardOriginArrow.escalated");
    case SQDCBoardEventStatus.DELEGATED:
      return t("components.event-action.issue.BoardOriginArrow.delegated");
    case SQDCBoardEventStatus.CREATED:
      return t("components.event-action.issue.BoardOriginArrow.created");
    default:
      return "";
  }
});
</script>

<style lang="scss" scoped></style>
